import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import type { LocationModel } from '@/entities/location';

import { LOCATION_TYPES } from '../../model/constants';
import { countLocationsByType } from '../../model/count-locations-by-type';
import { COUNTED_LOCATION_TYPES } from '../../model/types';

interface MapLocationCountsProps {
  locations: LocationModel[];
}

/** How many locations of each type the map has, next to the colour legend. */
export function MapLocationCounts({ locations }: MapLocationCountsProps) {
  const { t } = useTranslation();
  const counts = useMemo(() => countLocationsByType(locations), [locations]);

  return (
    <ul className="flex flex-wrap items-center justify-between gap-3 text-xs">
      {COUNTED_LOCATION_TYPES.map((type) => {
        const { Icon, color, label } = LOCATION_TYPES[type];

        return (
          <Tooltip key={type}>
            <TooltipTrigger asChild>
              <li className="flex cursor-help items-center gap-1">
                <Icon className={cn('h-4 w-4', color)} />
                {counts[type]}
              </li>
            </TooltipTrigger>
            <TooltipContent>
              <p>
                {t(label)}: {counts[type]}
              </p>
              <p className="text-muted-foreground">{t('welcome.map.locationcounts.desc')}</p>
            </TooltipContent>
          </Tooltip>
        );
      })}
    </ul>
  );
}
